export default __webpack_public_path__ + "static/media/work_portfolio_log.e01b873f.jpg";